export const SURVEY_RESULT_BY_ID_PATH = "/surveys-results/:participantId";
